module.exports = __webpack_public_path__ + "img/gentlemen.291718fc.jpg";